export const days = (date_1, date_2) => {
  const start_date = new Date(date_1 ?? new Date());
  const end_date = new Date(date_2 ?? new Date());
  let difference = end_date.getTime() - start_date.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24) + 1);

  return date_1 && date_2 ? TotalDays : 0;
};
